import script from "./MyRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./MyRequests.vue?vue&type=script&setup=true&lang=js"

import "./MyRequests.vue?vue&type=style&index=0&id=f57e5d30&lang=css"
import "./MyRequests.vue?vue&type=style&index=1&id=f57e5d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57e5d30"]])

export default __exports__